import React from 'react';
import styled from 'styled-components';
import { DynamicLink, DynamicLinkProps } from 'packages/smart-home-support/components';
import { getUrl } from '../../utils';
import { LinkId } from 'packages/smart-home-support/constants';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import refunds from './resources/refunds.jpg';
import whatsCovered from './resources/whats-covered.jpg';
import next from './resources/next.svg';

const s = {
  ActionGrid: styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 0px;
  `,
  Action: styled(DynamicLink)`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 25px;
    color: #000;
    text-decoration: none;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
  `,
  ActionImage: styled.div<ActionTitleProps>`
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    border-radius: 10px 10px 0px 0px;
    height: 150px;
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    color: white;
    padding-left: 20px;
    padding-bottom: 10px;
    background-color: #f6f6f6;
    background-image: url(${(props) => props.img});
    background-size: 100% 150%;
    background-position: bottom;
    @media ${BREAK_POINTS.tablet} {
      width: 225px;
    }
    @media ${BREAK_POINTS.desktop} {
      width: 310px;
    }
    @media ${BREAK_POINTS.desktopBig} {
      width: 370px;
    }
  `,
  ActionLabel: styled.div`
    margin-top: 20px;
    margin-bottom: 0;
    vertical-align: bottom;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
    padding-left: 20px;
    padding-right: 5px;
  `,
  ActionArrow: styled.img`
    float: right;
    height: 22px;
    width: 18px;
    padding-right: 5px;
  `,
  WellActionContainer: styled.div`
    display: flex;
    width: 100%;
    min-height: 68px;
    padding: 0px;
    border-width: 1px;
    border: 1px solid #d8dada;
    border-radius: 10px;
    background: #fff;
    margin-top: 16px;
    transition: border-color 0.2s, background-color 0.2s;
    &:hover {
      border-color: #a8aaaa;
    }
    @media ${BREAK_POINTS.tablet} {
      margin-right: 10px;
      width: 225px;
    }
    @media ${BREAK_POINTS.desktop} {
      margin-right: 10px;
      width: 310px;
    }
    @media ${BREAK_POINTS.desktopBig} {
      margin-right: 10px;
      width: 370px;
    }
  `,
};

type ActionProps = DynamicLinkProps & {
  image: string;
  label: string;
  title: string;
};

type ActionTitleProps = {
  img: string;
};

const Action: React.FC<ActionProps> = (props) => {
  return (
    <s.Action id={props.id} onClick={props.onClick} to={props.to} target={props.target}>
      <s.ActionImage img={props.image}>{props.title}</s.ActionImage>
      <s.ActionLabel>
        {props.label}
        <s.ActionArrow src={next} />
      </s.ActionLabel>
    </s.Action>
  );
};

const ContentCards: React.FC = () => {
  return (
    <s.ActionGrid>
      <s.WellActionContainer>
        <Action
          id={LinkId.DashboardHomeActionSeeWhatsCovered}
          title="What's covered?"
          label="See all plan benefits"
          image={whatsCovered}
          to="/whats-covered"
        />
      </s.WellActionContainer>
      <s.WellActionContainer>
        <Action
          id={LinkId.DashboardHomeActionShowMeRefundWarranties}
          title="Get Refunds for Old Tech Warranties"
          label="Show me how"
          image={refunds}
          to={getUrl('warranty-selection')}
        />
      </s.WellActionContainer>
    </s.ActionGrid>
  );
};

export default ContentCards;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/ContentCards.tsx